import React from 'react'
import {Loader} from 'semantic-ui-react'

export default function () {
  return (
    <Loader active inline='centered'>Loading</Loader>
  )
}



// WEBPACK FOOTER //
// ./src/components/loading/index.js